import axios from '../utils/axios';

export default function fetchClientDetails(adminId, id, params) {
    return (
        axios.get('/admin/' + adminId + '/client-details/' + id, { params })
    )
}
